import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router'

import { NAV } from '@brickup/shared/locales/de/nav'
import { EmailOverview } from '@/components/Internal/EmailManagement/EmailOverview'
import { Tabs } from '@/components/Internal/Tabs'

const SUBSCRIPTIONS = '/internal/system/operations/email/subscriptions'

const VIEW_TABS = [
  { id: 'logs', label: NAV.emailLogs, to: '/internal/system/operations/email' },
  { id: 'subscriptions', label: NAV.subscriptions, to: SUBSCRIPTIONS },
] as const

export const Route = createFileRoute('/internal/system/operations/email')({
  component: EmailLayout,
})

/**
 * The mailer, whole: what it has sent and who still hears from it.
 *
 * The two lists are routes of their own because each carries its own filters
 * in the address, and the status values they filter on are different sets.
 */
function EmailLayout() {
  const pathname = useLocation({ select: location => location.pathname })

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <EmailOverview />
      <Tabs
        layout="row"
        tabs={[...VIEW_TABS]}
        activeTab={pathname === SUBSCRIPTIONS ? 'subscriptions' : 'logs'}
      />
      <Outlet />
    </div>
  )
}
